import { CSSProperties, useMemo } from 'react';
import { CandleValidation } from 'client/voladeum/candle-validations/types';
import { useGridColumnContext } from 'framework/Grid/context/GridColumnContext';
import { useGridRowContext } from 'framework/Grid/context/GridRowContext';
import { colors } from 'framework/theme/constants/colors';

import { CANDLE_VALIDATION_ERROR_THRESHOLD } from '../../constants';

import cn from './Cell.module.scss';

export const GridMinutesCell = () => {
  const { row } = useGridRowContext<CandleValidation>();
  const { column } = useGridColumnContext();

  const color = useMemo((): CSSProperties['color'] => {
    if (row.minute_percent < CANDLE_VALIDATION_ERROR_THRESHOLD) {
      return colors.red[9];
    }
    return colors.light[1];
  }, [row]);

  return (
    <div className={cn.cell} style={{ justifyContent: column.text_align }}>
      <span style={{ color }}>
        {row.minute_count_formatted} ({row.minute_percent_formatted})
      </span>
    </div>
  );
};
